import { OneByOneRestfulGet } from "./dataFlowUtils";
import { OneByOneRestfulPost } from "./dataFlowUtils";

/**
 * Image storage base URL
 */
export const getImage = path => "https://media.1byonehealth.com/image" + path;

/**
 *  Get full product information with provided product Id
 */
export const getProductInfo = (productId, actionOnError) =>
  OneByOneRestfulGet(
    "getProductById",
    {
      id: productId
    },
    actionOnError
  );

/**
 * Get support content with provided subject
 */
export const getSupportContent = subject =>
  OneByOneRestfulGet("getSupportContent", {
    subject: subject
  });
/**
 * Get gateway campaign
 */
export const getGatewayCampaigns = requestParams =>
  OneByOneRestfulGet("/homepage/getCampaigns", requestParams);

/**
 *  Return products that meet the search criteria
 */
export const searchProduct = searchParams =>
  OneByOneRestfulGet("search", searchParams);

/**
 *  Perform sign up operation
 */
export const performSignUp = signUpRequest =>
  OneByOneRestfulPost("/ap/sign_up", signUpRequest);

/**
 *  Perform sign in operation
 */
export const performSignIn = signInRequest =>
  OneByOneRestfulPost("/ap/sign_in", signInRequest);

/**
 *  contact customer service operation
 */
export const contactCustomerService = contactCustomerServiceRequest =>
  OneByOneRestfulPost(
    "/cs/requestCustomerService",
    contactCustomerServiceRequest
  );

/**
 *  request refund & Exchange
 */
export const requestRefundExchange = refundExchangeRequest =>
  OneByOneRestfulPost("/cs/requestRefundExchange", refundExchangeRequest);

/**
 *  register product warranty
 */
export const registerProductWarranty = registerProductWarrantyRequest =>
  OneByOneRestfulPost("/cs/registerWarranty", registerProductWarrantyRequest);


 